
define('ldsh!modules/lp_integration/templates/zapier_popup', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-overlay-container popUp-integrateZappier">\n  <div class="ed-opt-toolbar ed-modal-header">\n    <div class="ed-close-wrapper">\n      <i class="ri-close-line js-cancel" data-dismiss="modal"></i>\n    </div>\n    <h3 data-i18n="integration.zapierModalTitle" class="ed-modal-title"></h3>\n  </div>\n\n  <div class="ed-modal-content ed-opt-content pr15">\n    <div class="ed-form-group">\n      <p class="mb32" data-i18n="integration.zapierFieldsDescription"></p>\n      <div class="ed-credentials">\n        <label class="ed-heading" data-i18n="integration.zapierUser"></label>\n        <label class="ed-info h44">' +
((__t = ( user_name )) == null ? '' : __t) +
'</label>\n      </div>\n      <div class="ed-credentials">\n        <label class="ed-heading" data-i18n="integration.zapierSecret"></label>\n        <label class="ed-info h44">' +
((__t = ( api_key )) == null ? '' : __t) +
'</label>\n      </div>\n    </div>\n\n    ';
 if (active) { ;
__p += '\n      <p data-i18n="integration.zapierActiveMessage"></p>\n    ';
 } else { ;
__p += '\n      <p data-i18n="integration.zapierInactiveMessage"></p>\n    ';
 } ;
__p += '\n\n    <div class="ed-help-text">\n      <a\n        href="https://mdirector.zendesk.com/hc/es/articles/360000461560-Integraci%C3%B3n-de-servicios-con-ZAPIER-"\n        target="_blank"\n        class="text--link"\n        data-i18n="integration.zapierHelp"\n      >\n      </a>\n    </div>\n  </div>\n  <div class="ed-opt-btnbar ed-modal-footer">\n    <button\n      class="js-save btn--ghost e100"\n      data-i18n="common.closeButton"\n    ></button>\n  </div>\n</div>\n';

}
return __p
};});

